'use client';

/**
 * PAGE BANNER — bandeau doré réutilisable (GOLDEN LUXE PRESTIGE).
 * Image + voile émeraude + titre dégradé or + sous-titre. Utilisé sur les
 * pages Royaumes (Sciences, Miracles, Salle Royale, Espace, Univers) et Médias.
 */
import Image from 'next/image';

interface Props {
  src: string;
  eyebrow: string;
  title: string;
  arabic?: string;
  sub?: string;
  height?: 'sm' | 'md';
}

export default function PageBanner({ src, eyebrow, title, arabic, sub, height = 'md' }: Props) {
  const h = height === 'sm' ? 'h-[200px] sm:h-[240px]' : 'h-[240px] sm:h-[300px]';
  return (
    <div className="relative overflow-hidden border-b border-[rgba(212,175,55,0.3)]" aria-hidden={false}>
      <Image
        src={src}
        alt=""
        width={1440}
        height={704}
        priority
        unoptimized
        className={`${h} w-full object-cover`}
      />
      <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(2,25,19,0.5),rgba(3,32,25,0.92))]" aria-hidden />
      <div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">
        <p className="mb-2 text-[11px] font-bold uppercase tracking-[0.4em] text-[#f0d98c]/90">{eyebrow}</p>
        <h1 className="font-serif-royal text-4xl font-bold sm:text-5xl">
          <span className="text-gold-gradient">{title}</span>
        </h1>
        {arabic && (
          <p className="font-arabic mt-1 text-2xl text-[#f0d98c]" dir="rtl" lang="ar">
            {arabic}
          </p>
        )}
        {sub && <p className="mx-auto mt-3 max-w-2xl text-xs leading-relaxed text-[#cfe0cf]/85 sm:text-sm">{sub}</p>}
      </div>
    </div>
  );
}
